import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import MemberList from './pages/MemberList';
import MemberDetail from './pages/MemberDetail';

// Protects child routes by checking for a valid token
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" replace />;
};

const App = () => (
  <BrowserRouter>
    <Routes>
      {/* Public login route */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes under root path */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        {/* Default: redirect to members list */}
        <Route index element={<Navigate to="members" replace />} />

        {/* Members routes */}
        <Route path="members" element={<MemberList />} />
        <Route path="members/:id" element={<MemberDetail />} />
      </Route>

      {/* Fallback for unknown paths */}
      <Route
        path="*"
        element={<Navigate to="/login" replace />}
      />
    </Routes>
  </BrowserRouter>
);

export default App;
